<template>
  <section class="section hero-section" :class="{ 'is-english': $i18n.locale === 'en' }">
    <div class="hero-content">
      <div class="hero-kicker">
        <span class="material-icons">graphic_eq</span>
        {{ $t('home.kicker') }}
      </div>
      <h1 class="main-heading">
        {{ $t('home.heroTitle') }}
      </h1>
      <HomeSubtitle
        ref="subtitleText"
        :text="$t('home.subtitle')"
        :speed="900"
      />
      <p class="hero-description">
        {{ $t('home.heroDescription') }}
      </p>
      <div class="action-buttons">
        <button @click="$emit('start')" class="btn btn-primary">
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
          {{ $t(isLoggedIn ? 'home.startButton' : 'home.loginToStart') }}
        </button>
        <button @click="$emit('demo')" class="btn btn-secondary">
          <span class="material-icons-outlined" aria-hidden="true">headphones</span>
          {{ $t('home.tryDemo') }}
        </button>
      </div>
      <MainlandAccessNotice />
      <p class="desktop-recommend-notice" role="note">
        <span class="material-icons" aria-hidden="true">laptop</span>
        {{ $t('home.desktopRecommendNotice') }}
      </p>
    </div>

    <button
      type="button"
      class="hero-shot"
      :aria-label="$t('home.heroShot.aria')"
      @click="$emit('demo')"
    >
      <span class="hero-shot-frame">
        <!-- 静音循环的跟读录屏；系统设置了减少动态效果时只显示首帧 -->
        <video
          :key="heroShotName"
          class="hero-shot-image"
          :src="`${assetBase}${heroShotName}.mp4`"
          :poster="`${assetBase}${heroShotName}-poster.webp`"
          width="1600"
          height="704"
          :aria-label="$t('home.heroShot.alt')"
          :autoplay="!reducedMotion"
          muted
          loop
          playsinline
        ></video>
      </span>
      <span class="hero-shot-hint" aria-hidden="true">
        <span class="material-icons">play_arrow</span>
        {{ $t('home.heroShot.action') }}
      </span>
    </button>
  </section>
</template>

<script>
import HomeSubtitle from './HomeSubtitle.vue';
import MainlandAccessNotice from '@/components/common/MainlandAccessNotice.vue';

export default {
  name: 'HomeHeroPreview',
  components: {
    HomeSubtitle,
    MainlandAccessNotice
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      assetBase: `${process.env.BASE_URL}assets/`,
      reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
    };
  },
  computed: {
    heroShotName() {
      return this.$i18n.locale === 'en' ? 'hero-en' : 'hero-zh';
    }
  },
  emits: ['start', 'demo']
};
</script>
